module.exports = __webpack_public_path__ + "img/code.0260e4cc.png";